import { useEffect, useState } from "react";
import {
  teamsLightTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  type Theme,
} from "@fluentui/react-components";

const THEME_MAP: Record<string, Theme> = {
  default: teamsLightTheme,
  dark: teamsDarkTheme,
  contrast: teamsHighContrastTheme,
};

/**
 * Follow the Teams client theme (light/dark/high-contrast). Outside Teams it
 * stays on the light theme, which is what the local mock demo uses.
 */
export function useTeamsTheme(): Theme {
  const [theme, setTheme] = useState<Theme>(teamsLightTheme);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { app } = await import("@microsoft/teams-js");
        await app.initialize();
        const ctx = await app.getContext();
        if (mounted) setTheme(THEME_MAP[ctx.app.theme] ?? teamsLightTheme);
        app.registerOnThemeChangeHandler((t: string) => {
          setTheme(THEME_MAP[t] ?? teamsLightTheme);
        });
      } catch {
        // Not inside Teams — keep the light theme.
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return theme;
}
